import { bool, color, element, expression, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const SuperscriptionItemProperties = {
    className: {
        type: string,
    },
    color: {
        type: color,
    },
    icon: {
        type: oneOfType([string, element]),
    },
    label: {
        defaultValue: '',
        type: expression,
    },
    showLabel: {
        type: bool,
    },
    value: {
        type: string,
    },
};
export { SuperscriptionItemProperties, };
//# sourceMappingURL=superscription-item-types.js.map